import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getUserProfileFollowingIds = async ({ uid }) => {
	try {
		const userProfileDocRef = firestore.collection('userProfiles').doc(uid)

		const followingQuerySnap = await userProfileDocRef.collection('following').get()

		return followingQuerySnap.docs.map(d => d.id)
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, error)
	}
}

export default getUserProfileFollowingIds



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfileFollowingIds.js